import { Box } from "@chakra-ui/react";

export default function AsParagraphs({
  Component,
  spacing,
  children,
  ...rest
}) {
  const paragraphs = children.split("\n");
  return (
    <Box {...rest}>
      {paragraphs.map((paragraph, index) => (
        <Box key={index} mb={index === paragraphs.length - 1 ? 0 : spacing}>
          <Component>{paragraph}</Component>
        </Box>
      ))}
    </Box>
  );
}
